import { Pagination, PaginationV2 } from './Pagination';

export class PickupDashboardMonitoringCourierSummary {
  status = "";
  seller = 0;
  courier = 0;
  shipment = 0;
  quantity = 0;

  constructor(fields?: Partial<PickupDashboardMonitoringCourierSummary>) {
    Object.assign(this, fields);
  }
}

export class CourierPickupSummary {
  data: PickupDashboardMonitoringCourierSummary[] = [];

  constructor(fields?: Partial<CourierPickupSummary>) {
    Object.assign(this, fields);
    if (fields?.data) {
      this.data = fields.data.map(d => new PickupDashboardMonitoringCourierSummary(d));
    }
  }
}

export class AvailableCourier {
  courierId = 0;
  courierName = "";
  courierPhone = "";
  courierType = "";

  constructor(fields?: Partial<AvailableCourier>) {
    Object.assign(this, fields);
  }
}

export class AvailableCourierList {
  data: AvailableCourier[] = [];

  constructor(fields?: Partial<AvailableCourierList>) {
    Object.assign(this, fields);
    if (fields?.data) {
      this.data = fields.data.map(d => new AvailableCourier(d));
    }
  }
}

export class TransferPickupRequest {
  task_group_id: number[] = [];
  courier_id = 0;

  constructor(fields?: Partial<TransferPickupRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return {
      // eslint-disable-next-line @typescript-eslint/camelcase
      task_group_id: this.task_group_id,
      // eslint-disable-next-line @typescript-eslint/camelcase
      courier_id: this.courier_id
    };
  }
}

export class SenderData {
  id = "";
  courierId = 0;
  courierName = "";
  courierPhone = "";
  senderName = "";
  senderPhone = "";
  senderAddress = "";
  shipmentType = "";
  shipmentId = "";
  totalShipment = 0;
  totalQuantity = 0;
  totalWeight = 0;
  expiredAt = "";
  status = "";
  statusAt = "";
  proofs: string[] = [];
  isAbleToBooking = false;
  lat = 0;
  lon = 0;
  taskGroupId = 0;

  constructor(fields?: Partial<SenderData>) {
    Object.assign(this, fields);
    // Use taskGroupId as unique identifier if no id is provided
    if (!this.id && this.taskGroupId) {
      this.id = this.taskGroupId.toString();
    }
  }
}

export class PickupDashboardMonitoringCourierShipment {
  courierId = 0;
  courierName = "";
  courierPhone = "";
  senderName = "";
  senderPhone = "";
  senderAddress = "";
  shipmentType = "";
  shipmentId = "";
  totalShipment = 0;
  totalQuantity = 0;
  totalWeight = 0;
  statusAt = "";
  status = "";
  proofs = [];
  isAbleToBooking = false;
  lat = 0;
  lon = 0;
  taskGroupId = 0;
  isChecked = false;

  constructor(fields?: Partial<PickupDashboardMonitoringCourierShipment>) {
    Object.assign(this, fields);
  }
}

export class CourierPickupShipment {
  data: PickupDashboardMonitoringCourierShipment[] = [];
  pagination: PaginationV2 = new PaginationV2();

  constructor(fields?: Partial<CourierPickupShipment>) {
    Object.assign(this, fields);
  }
}

export class PickupDashboardMonitoringCourierPickup {
  status = "";
  seller = 0;
  shipment = 0;
  quantity = 0;
  isWithinTimeLimit = false;

  constructor(fields?: Partial<PickupDashboardMonitoringCourierPickup>) {
    Object.assign(this, fields);
  }
}

export class PickupDashboardMonitoringCourierData {
  courierId = 0;
  courierName = "";
  courierPhone = "";
  pickup: PickupDashboardMonitoringCourierPickup[] = [];

  constructor(fields?: Partial<PickupDashboardMonitoringCourierData>) {
    Object.assign(this, fields);
  }
}

export class PickupDashboardMonitoringCourierPickupEntities {
  data: PickupDashboardMonitoringCourierData[] = [];
  pagination: Pagination = new Pagination(1, 10, 0);

  constructor(fields?: PickupDashboardMonitoringCourierPickupEntities) {
    Object.assign(this, fields);
  }
}

export class SenderList {
  data: SenderData[] = [];
  meta = {
    totalRecords: 0,
    currentPage: 1,
    totalPages: 1,
    limit: 20
  };

  constructor(fields?: Partial<SenderList>) {
    Object.assign(this, fields);
    if (fields?.data) {
      this.data = fields.data.map((d) => new SenderData(d));
    }
  }
}

export class TransferPickupListRequest {
  courier_id = 0;
  start_date = "";
  end_date = "";
  status = "CRROTW";
  q = "";
  shipment_type = "";
  page = 1;
  limit = 10;
  sort_by = "";
  order_by = "";

  constructor(fields?: Partial<TransferPickupListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    const params = new URLSearchParams();

    if (this.courier_id)
      params.append("courier_id", this.courier_id.toString());
    if (this.start_date) params.append("start_date", this.start_date);
    if (this.end_date) params.append("end_date", this.end_date);
    if (this.status) params.append("status", this.status);
    if (this.q) params.append("q", this.q);
    if (this.shipment_type) params.append("shipment_type", this.shipment_type);
    if (this.page) params.append("page", this.page.toString());
    if (this.limit) params.append("limit", this.limit.toString());
    if (this.sort_by) params.append("sort_by", this.sort_by);
    if (this.order_by) params.append("order_by", this.order_by);

    return params.toString();
  }
}

export class ManualAssignData {
  courierId = 0;
  courierName = "";
  courierPhone = "";
  senderName = "";
  senderPhone = "";
  senderAddress = "";
  shipmentType = "";
  shipmentId = "";
  totalShipment = 0;
  totalQuantity = 0;
  totalWeight = 0;
  expiredAt = "";
  statusAt = "";
  status = "";
  proofs = [];
  isAbleToBooking = false;
  lat = 0;
  lon = 0;
  taskGroupId = 0;
  isSuccess = false;

  constructor(fields?: Partial<ManualAssignData>) {
    Object.assign(this, fields);
  }
}

export class ManualAssignResponse {
  data: ManualAssignData[] = [];

  constructor(fields?: Partial<ManualAssignResponse>) {
    Object.assign(this, fields);
  }
}
